import { AccountSource, Address, CustomSource, Hex, InvalidAddressErrorType, IsAddressErrorType, JsonRpcAccount, LocalAccount } from "viem";
import { BigNumber, BigNumberish } from "./bignumber";
import { UserOperation } from "../common";
import { ErrorType } from "node_modules/viem/_types/errors/utils";
import { BytesLike } from "./common-types";

export type AccountType = 'erc7579-implementation'

export type PromiseOrValue<T> = T | Promise<T>;

export type BaseAccountUserOperationStruct = {
    sender: PromiseOrValue<string>;
    nonce: PromiseOrValue<BigNumberish>;
    initCode: PromiseOrValue<BytesLike>;
    callData: PromiseOrValue<BytesLike>;
    accountGasLimits: PromiseOrValue<BytesLike>;
    preVerificationGas: PromiseOrValue<BigNumberish>;
    gasFees: PromiseOrValue<BytesLike>;
    paymasterAndData: PromiseOrValue<BytesLike>;
    signature: PromiseOrValue<BytesLike>;
};

export type UserOperationStruct = {
    sender: PromiseOrValue<string>;
    nonce: PromiseOrValue<BigNumberish>;
    initCode: PromiseOrValue<BytesLike>;
    callData: PromiseOrValue<BytesLike>;
    callGasLimit: PromiseOrValue<BigNumberish>;
    verificationGasLimit: PromiseOrValue<BigNumberish>;
    preVerificationGas: PromiseOrValue<BigNumberish>;
    maxFeePerGas: PromiseOrValue<BigNumberish>;
    maxPriorityFeePerGas: PromiseOrValue<BigNumberish>;
    paymasterAndData: PromiseOrValue<BytesLike>;
    signature: PromiseOrValue<BytesLike>;
};

export interface FeeData {
    lastBaseFeePerGas: null | BigNumber;
    maxFeePerGas: null | BigNumber;
    maxPriorityFeePerGas: null | BigNumber;
    gasPrice: null | BigNumber;
}

// Extended LocalAccount type with a custom function
export type ExtendedLocalAccount<
  source extends string = string,
  address extends Address = Address,
> = LocalAccount<source, address> & {
  //signUserOp: () => void
  signUserOpWithRemoteSigner(userOp: UserOperation) : Promise<UserOperation>
}


export type GetAccountReturnType<accountSource extends AccountSource> =
  | (accountSource extends Address ? JsonRpcAccount : never)
  | (accountSource extends CustomSource ? LocalAccount : never)

export type ToAccountErrorType =
  | InvalidAddressErrorType
  | IsAddressErrorType
  | ErrorType


  export type InitialModules = {
    validators: Module[]
    executors: Module[]
    hooks: Module[]
    fallbacks: Module[]
  }
  
  export type ModuleType = 'validator' | 'executor' | 'fallback' | 'hook'
  
  export type Module = {
    module: Address
    data?: Hex
    additionalContext?: Hex
    type: ModuleType
  }
  
  export type ModuleTypeIds = {
    [index in ModuleType]: number
  }
  
  export const moduleTypeIds: ModuleTypeIds = {
    validator: 1,
    executor: 2,
    fallback: 3,
    hook: 4,
  }
  